import { ComponentType } from 'components/SalaryComponents/types';

export const SalaryStructureComponentValueTypeLabels = {
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC: {
    label: 'Percentage',
  },
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_FIXED: {
    label: 'Yearly amount',
  },
};

export const salaryStructureComponentType = {
  COMPONENT_TYPE_NA: 'COMPONENT_TYPE_NA',
  COMPONENT_TYPE_BASIC: 'COMPONENT_TYPE_BASIC',
  COMPONENT_TYPE_DA: 'COMPONENT_TYPE_DA',
  COMPONENT_TYPE_HRA: 'COMPONENT_TYPE_HRA',
  COMPONENT_TYPE_SPECIAL_ALLOWANCE: 'COMPONENT_TYPE_SPECIAL_ALLOWANCE',
  COMPONENT_TYPE_LTA: 'COMPONENT_TYPE_LTA',
  COMPONENT_TYPE_OTHER_ALLOWANCE: 'COMPONENT_TYPE_OTHER_ALLOWANCE',
  COMPONENT_TYPE_OTHER_DEDUCTION: 'COMPONENT_TYPE_OTHER_DEDUCTION',
  COMPONENT_TYPE_GRATUITY: 'COMPONENT_TYPE_GRATUITY',
  COMPONENT_TYPE_LEAVE_ENCASHMENT: 'COMPONENT_TYPE_LEAVE_ENCASHMENT',
  COMPONENT_TYPE_VARIABLE: 'COMPONENT_TYPE_VARIABLE',
  COMPONENT_TYPE_NON_PAYABLE_BENEFIT: 'COMPONENT_TYPE_NON_PAYABLE_BENEFIT',
} as const;

export const predefinedComponentTypes: ComponentType[] = [
  'COMPONENT_TYPE_BASIC',
  'COMPONENT_TYPE_SPECIAL_ALLOWANCE',
  'COMPONENT_TYPE_DA',
  'COMPONENT_TYPE_HRA',
  'COMPONENT_TYPE_LTA',
];

export const deletablePredfinedComponentTypes: ComponentType[] = [
  'COMPONENT_TYPE_DA',
  'COMPONENT_TYPE_HRA',
  'COMPONENT_TYPE_LTA',
];

export const nonDeletablePredfinedComponentTypes: ComponentType[] = [
  'COMPONENT_TYPE_BASIC',
  'COMPONENT_TYPE_SPECIAL_ALLOWANCE',
];

export const salaryStrcutureComponentValueType = {
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC: 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC',
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_BASIC: 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_BASIC',
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_FIXED: 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_FIXED',
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_SA: 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_SA',
} as const;
